import { SelectAsyncInput } from '@core/components/Select';
import { parseHeaderForLinks } from '@core/util';
import { produtoServicoApi } from 'app/services/api/produtoServicoApi';
import React from 'react';

const SelectProdutoVenda = ({
  id,
  name,
  label,
  value,
  touched,
  error,
  onBlur,
  onChange,
  disabled,
  aceitaProdutoImobilizado = false,
}) => {
  return (
    <>
      <SelectAsyncInput
        id={id}
        name={name}
        label={label}
        value={value}
        onChange={(event, value) => {
          onChange({
            target: {
              id,
              value,
            },
          });
        }}
        onClearInput={() => {
          onChange({ target: { id, value: undefined } });
        }}
        touched={touched}
        error={error}
        onBlur={onBlur}
        getOptionKey={(option) => {
          return option?.produtoId || option?.servicoId;
        }}
        getOptionLabel={(option) => {
          return option?.nome;
        }}
        fetchData={async (query = '', next = 0) => {
          if (typeof query === 'object') {
            query = '';
          }
          const response = await produtoServicoApi.pesquisar({
            size: 100,
            sort: 'nome',
            page: next,
            q: query,
            aceitaProdutoImobilizado: aceitaProdutoImobilizado,
          });

          const links = parseHeaderForLinks(response.headers.link);
          const totalItems = response.headers['x-total-count'];
          let data = [];

          if (response?.data) {
            data = response?.data.filter((p) => !!p.produtoId) || [];
          }

          return { data, nextPage: links.next, totalItems };
        }}
        fetchOnFocus
        disabled={disabled}
      />
    </>
  );
};

export default SelectProdutoVenda;
